var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticClass:"dialog_wrapper",attrs:{"value":_vm.isOpen,"max-width":_vm.width,"persistent":"","transition":"slide-x-reverse-transition"}},[(_vm.type)?_c('cancel-form',{attrs:{"type":_vm.type,"modalData":_vm.payload},on:{"closeDialog":_vm.close}}):_vm._t("dialogContent")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }